import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilesComponent, Loader, Notes, SimpleTabs, VideoFiles } from 'components';
import { fileEnums, FindLoad, noteModels, PermissionList, RolePermission, videoModelEnums } from 'utils';
import { fundingSourceActions, goalActions } from 'store';
import { GoalDetailInfo, GoalDetailsHeader } from './goalDetailFragments';
import { MasteryOption } from './mastery';
import { HistoryTab } from '../../../../history';
import { Targets } from './targets';
import { DataCollection } from './dataCollection';
import { formModelEnums } from 'pages';
import { eventOnModel, Events } from 'fragments';
import { GoalProgressTab } from './clinicalInsights';

const goalDetailsLabels = [
    { label: 'Details' },
    { label: 'Targets' },
    { label: 'Progress Rules' },
    { label: 'Events' },
    { label: 'Session History' },

    { label: 'Goal Progress' },
    { label: 'Videos' },
    { label: 'Notes' },
    { label: 'Files' },
    RolePermission([PermissionList.GOAL_HISTORY_READ?.code]) && { label: 'History' },
];

const ACTION_TYPE = 'GET_GOAL_BY_ID';
export const GoalDetails = ({ goalId, requestParams, defaultTab, clientId, afterSuccess }) => {
    const [tab, setTab] = useState(defaultTab ? defaultTab : 'Details');
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const goalById = useSelector((state) => state.goals.goalById);

    useEffect(() => {
        if (goalId) {
            dispatch(goalActions.getGoalById(goalId));
        }
    }, [dispatch]);

    const tabsContent = [
        {
            tabComponent: <GoalDetailInfo requestParams={requestParams} />,
            tab: 'Details',
        },
        {
            tabComponent: <Targets requestParams={requestParams} />,
            tab: 'Targets',
        },
        {
            tabComponent: <MasteryOption />,
            tab: 'Progress Rules',
        },
        {
            tabComponent: <Events model={{ resource: goalId, onModel: eventOnModel.Goal }} permissions={[PermissionList.GOAL_CREATE?.code]} />,
            tab: 'Events',
        },
        {
            tabComponent: <DataCollection goalId={goalId} />,
            tab: 'Session History',
        },
        {
            tabComponent: <GoalProgressTab goalId={goalId} clientId={clientId} requestParams={requestParams} />,
            tab: 'Goal Progress',
        },
        {
            tabComponent: (
                <VideoFiles
                    afterSuccess={() => dispatch(goalActions.getGoalById(goalId, 'noLoad'))}
                    resourceId={goalId}
                    model={videoModelEnums.GOAL_INSTRUCTION}
                    videos={goalById?.instructionVideos}
                />
            ),
            tab: 'Videos',
        },
        {
            tabComponent: (
                <Notes
                    id={goalId}
                    onModel={noteModels.Goal}
                    formModel={formModelEnums.GOALNOTES}
                    permissions={[PermissionList.ALL_ACCESS?.code]}
                />
            ),
            tab: 'Notes',
        },
        {
            tabComponent: (
                <FilesComponent currentId={goalId} onResource={fileEnums.GOAL} permissions={[PermissionList.CLIENT_FILE_MANAGE?.code]} />
            ),
            tab: 'Files',
        },
        RolePermission([PermissionList.GOAL_HISTORY_READ?.code]) && {
            tabComponent: <HistoryTab currentId={goalId} onModel={'Goal'} />,
            tab: 'History',
        },
    ];

    if (loader?.length) {
        return (
            <div style={{ width: 1400, maxWidth: '100%' }}>
                <Loader type={'page'} />
            </div>
        );
    }

    return (
        <div style={{ width: 1400, maxWidth: '100%' }}>
            <GoalDetailsHeader requestParams={requestParams} afterSuccess={afterSuccess} />
            <SimpleTabs
                tab={tab}
                getTab={setTab}
                defaultTab={
                    RolePermission([
                        PermissionList.CLIENT_READ?.code,
                        PermissionList.CLIENT_CREATE?.code,
                        PermissionList.CLIENT_STATUS?.code,
                    ])
                        ? 'General'
                        : ''
                }
                tabsLabels={goalDetailsLabels}
                tabsContent={tabsContent}
            />
        </div>
    );
};
